import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppState, PRODUCT_FEATURE } from "../../../app.state";

export const productFeature = createFeatureSelector<AppState>(PRODUCT_FEATURE.stateKey);
export const selectLoading = createSelector(
  productFeature,
  (state: AppState) =>{ return state.related_products.isLoading}
);
export const selectItems = createSelector(
  productFeature,
  (state: AppState) => state.related_products.data
);
